import { isWeb } from '@gluestack-ui/nativewind-utils/IsWeb';
import { Redirect } from 'expo-router';

import { ContentLibrary } from '@/components/contentLibrary';
import { ROUTES } from '@/constants/routes';

/**
 * Native has no standalone content library: it is the Content Posts tab of the Library
 * tab, which carries the header, the tabs and the bottom bar. This route sits outside
 * the tab navigator, so rendering the list here would be a screen with no bar. Web keeps
 * the bare list under its nav bar.
 *
 * The redirect names the tab through its route group. A plain community path also matches
 * the stack route of the same name, which wins and would land on the bare list again.
 */
export default function SecureContentLibrary() {
  if (isWeb) {
    return <ContentLibrary />;
  }

  return <Redirect href={ROUTES.LIBRARY_TAB_CONTENT_POSTS} />;
}
